// lib/data.js — all static content in one place

export const STUDIOS = [
  { src: "Netflix.png",               alt: "Netflix" },
  { src: "Amazon Prime.png",          alt: "Amazon Prime" },
  { src: "Marvel.png",                alt: "Marvel Studios" },
  { src: "DC.png",                    alt: "DC" },
  { src: "20th century fox.png",      alt: "20th Century" },
  { src: "SonyLIV.png",               alt: "SET India" },
  { src: "Color Yellow.png",          alt: "Color Yellow" },
  { src: "jiohotstar.png",            alt: "Jio Hotstar" },
  { src: "Offroad-logo-yellow.png",   alt: "Offroad" },
  { src: "CNN.png",                   alt: "CNN" },
  { src: "Apple TV.png",              alt: "Apple TV" },
  { src: "BBC.png",                   alt: "BBC" },
  { src: "hulu.png",                  alt: "Hulu" },
  { src: "Warner Bros.png",           alt: "Warner Bros" },
  { src: "Maed in India Logo.png",    alt: "Maed In India" },
  { src: "uefa-champions-league.png", alt: "UEFA" },
];

export const MOVIES = [
  { file: "Alita battle angel",                    title: "Alita: Battle Angel" },
  { file: "Avengers- Endgame",                     title: "Avengers: Endgame" },
  { file: "John Wick",                             title: "John Wick" },
  { file: "Sonic the Hedgehog 3",                  title: "Sonic the Hedgehog 3" },
  { file: "ant man and the wast quantumania",      title: "Ant-Man: Quantumania" },
  { file: "Kingdom of the Planet of the Apes",     title: "Planet of the Apes" },
  { file: "Tu Yaa Main",                           title: "Tu Yaa Main" },
  { file: "Shehar Lakhot",                         title: "Shehar Lakhot" },
  { file: "Devil May Cry",                         title: "Devil May Cry" },
  { file: "Stranger Things",                       title: "Stranger Things" },
  { file: "Squid Game",                            title: "Squid Game" },
  { file: "Lord of the rings",                     title: "Lord of the Rings" },
  { file: "The Last of us",                        title: "The Last of Us" },
  { file: "One Piece",                             title: "One Piece" },
  { file: "House of dragon",                       title: "House of the Dragon" },
  { file: "Bridgerton",                            title: "Bridgerton" },
  { file: "The Boys",                              title: "The Boys" },
  { file: "Black Mirror",                          title: "Black Mirror" },
  { file: "The Night Agent",                       title: "The Night Agent" },
  { file: "The witcher",                           title: "The Witcher" },
  { file: "Shogun",                                title: "Shōgun" },
  { file: "Severance",                             title: "Severance" },
  { file: "The White Lotus",                       title: "The White Lotus" },
  { file: "Silo",                                  title: "Silo" },
  { file: "Monarch Legacy of monsters",            title: "Monarch: Legacy of Monsters" },
  { file: "Good Omens",                            title: "Good Omens" },
  { file: "American Horror stories",               title: "American Horror Story" },
  { file: "Invincible",                            title: "Invincible" },
  { file: "Euphoria",                              title: "Euphoria" },
];

export const CATALOG = [
  { name: "Gothic Storm",       genre: "Orchestral / Trailer" },
  { name: "Amadea Music",       genre: "Cinematic / Hybrid" },
  { name: "ZIK",                genre: "World / Ambient" },
  { name: "911 True Crime",     genre: "Crime / Dark" },
  { name: "Atom Music Audio",   genre: "Trailer / Epic" },
  { name: "Megatrax",           genre: "Pop / Commercial" },
  { name: "Silk Road",          genre: "World / Regional" },
  { name: "Squirky Jazz",       genre: "Jazz / Comedy" },
  { name: "Podcast+",           genre: "Talk / Underscore" },
  { name: "FiXT New Noise",     genre: "Electronic / Rock" },
  { name: "Dronebox",           genre: "Ambient / Drone" },
  { name: "Hitpoint Music",     genre: "Cinematic / Score" },
  { name: "SIIX Trailer",       genre: "Trailer / Hybrid" },
  { name: "Sensacion",          genre: "Latin / World" },
  { name: "Howling Music",      genre: "Indie / Alt" },
  { name: "Strike Audio",       genre: "Action / Tension" },
  { name: "Canopo Vintage",     genre: "Vintage / Retro" },
  { name: "Music for Sport",    genre: "Sports / Energetic" },
  { name: "earthMusic",         genre: "Documentary" },
  { name: "DramaTracks",        genre: "Drama / Emotional" },
];

export const PLANS = [
  {
    id: "free", name: "Free", tag: "No card details required",
    monthly: 0, yearly: 0,
    saveMo: " ",
    saveYr: " ",
    features: ["Full access to the music", "Full access to AI search", "1M+ track catalog", "Create project folders"],
    disabled: ["Download", "Create a license"],
    cta: "Start Free Trial", href: "/register/free",
    featured: false, accent: "teal",
  },
  {
    id: "solo", name: "Solo", tag: "License music for your own content only",
    monthly: 799, yearly: 600,
    saveMo: "Save 3 months with annual billing",
    saveYr: "₹7,200 billed yearly · Save 25%",
    features: ["Everything in Free", "Unlimited downloads", "Personal use licences", "1 channel/platform", "Vlogs, podcasts, stand-up", "Perpetual worldwide licence"],
    disabled: [],
    cta: "Get Started", href: "/register/solo",
    featured: false, accent: "navy",
  },
  {
    id: "pro", name: "Pro", tag: "License for clients and commercial use",
    monthly: 1999, yearly: 1499,
    saveMo: "Save 3 months with annual billing",
    saveYr: "₹17,988 billed yearly · Save 25%",
    features: ["Everything in Solo", "Up to 5 client projects", "Digital ads for clients", "Film - Festival Exhibition Only", "5 channels per platform", "Perpetual worldwide licence"],
    disabled: [],
    cta: "Get Started", href: "/register/pro",
    featured: true, badge: "Most Popular", accent: "pink",
  },
  {
    id: "corporate", name: "Corporate", tag: "For teams, agencies and production houses",
    monthly: null, yearly: null,
    saveMo: "Special agency rates available",
    saveYr: "Special agency rates available",
    features: ["Everything in Pro", "Multiple user accounts", "Broadcast — Radio & TV", "VOD — Jio, Zee, Sony, Netflix, Amazon, Apple TV", "Gaming & in-app music", "Dedicated account manager"],
    disabled: [],
    cta: "Request Quote", href: "/contact",
    featured: false, accent: "gold",
  },
];

export const TYPING_PROMPTS = [
  "एक पिता अपनी छोटी बेटी को सुबह की सुनसान सड़क पर साइकिल चलाना सिखा रहा है। वो गिरती है, उठती है, फिर गिरती है। वो सीट छोड़ देता है। वो पहली बार अकेले चलाती है — हँसते हुए। म्यूज़िक: हल्की अकॉस्टिक गिटार, नरम रिदम, धीरे-धीरे बढ़ती गर्माहट। एक बाप का फ़ख्र, प्यार, और ज़िंदगी के छोटे-छोटे जादू। 0:30।",
  "A father teaches his young daughter to ride a bicycle on an empty morning road in a small town. She falls, gets up, falls again. He lets go of the seat. She rides alone for the first time, laughing. Music: light acoustic guitar, gentle rhythm, building warmth. Pride, love, and everyday magic. 0:30.",
  "ఒక చిన్న పట్టణంలో తెల్లవారుజామున నిర్జనంగా ఉన్న రోడ్డుపై తండ్రి తన చిన్న కూతురికి సైకిల్ నేర్పిస్తున్నాడు। ఆమె పడిపోతుంది, లేస్తుంది, మళ్ళీ పడిపోతుంది। అతను సీట్ వదిలేస్తాడు। ఆమె మొదటిసారి ఒంటరిగా తొక్కుతుంది — నవ్వుతూ। మ్యూజిక్: మెత్తటి అకౌస్టిక్ గిటార్, సున్నితమైన రిదమ్, నెమ్మదిగా పెరిగే వెచ్చదనం। తండ్రి గర్వం, ప్రేమ, మరియు రోజువారీ జీవితంలోని చిన్న అద్భుతాలు। 0:30।",
  "একটি ছোট শহরে ভোরের ফাঁকা রাস্তায় এক বাবা তার ছোট্ট মেয়েকে সাইকেল চালাতে শেখাচ্ছেন। সে পড়ে যায়, উঠে দাঁড়ায়, আবার পড়ে। বাবা সিট ছেড়ে দেন। সে প্রথমবার একা চালায় — হাসতে হাসতে। মিউজিক: হালকা অ্যাকুস্টিক গিটার, মৃদু ছন্দ, আস্তে আস্তে বাড়তে থাকা উষ্ণতা। বাবার গর্ব, ভালোবাসা, আর রোজকার জীবনের ছোট্ট জাদু। 0:30।",
  "एका छोट्याशा गावात सकाळच्या शांत रस्त्यावर बाबा आपल्या लहान मुलीला सायकल शिकवत आहेत। ती पडते, उठते, पुन्हा पडते। बाबा सीट सोडतात। ती पहिल्यांदा एकटी सायकल चालवते — हसत हसत। म्युझिक: हलकी अकॉस्टिक गिटार, मऊ ताल, हळूहळू वाढत जाणारी ऊब। बाबांचा अभिमान, प्रेम, आणि रोजच्या आयुष्यातला एक छोटासा चमत्कार। 0:30।",
];

export const WF_HEIGHTS = [
  22,38,58,42,72,88,63,47,82,92,68,52,77,90,65,50,76,60,44,70,
  84,57,43,69,83,61,48,74,58,42,68,80,55,41,67,78,54,40,66,82,
  60,46,72,86,64,50,76,54,40,66,80,57,43,69,85,62,48,74,52,38,
  64,78,55,41,67,83,58,44,70,86,65,50,77,45,62,85,59,45,71,87,
];

export const LICENCE_STEPS = [
  { n: "01", title: "Search & find your track",   body: "Use any of the four AI search modes to find the perfect track in seconds." },
  { n: "02", title: "Add to a project",           body: "Create a project folder, add your selected tracks, download for your edit." },
  { n: "03", title: "Generate your licence",      body: "One click. Instant PDF with your name, track details, scope and territory." },
  { n: "04", title: "Monetise anywhere, forever", body: "Your content is protected worldwide, in perpetuity. Even after cancellation." },
];

export const BARS = [
  { label: "Silk Road Communications", value: "2,902,917", pct: 100, cls: "silk-road" },
  { label: "Universal Music India", value: "2,069,432", pct: 61.8, cls: "universal" },
  { label: "Sony Music India", value: "1,325,275", pct: 47, cls: "sony" },
  { label: "Warner Music India", value: "777,544", pct: 28.3, cls: "warner" },
];
